export default __webpack_public_path__ + "static/media/layer6.c8d290ad.webp";